export default {
      id: "observation-negative-usage",
      viewBox: "0 0 56 56",
      url: __webpack_public_path__ + "sprite.svg#observation-negative",
      toString: function () {
        return this.url;
      }
    }